import { useEffect, useState } from "react";
import "./AdminBanner.css";
import AdminBannerEditar from "./AdminBannerEditar/AdminBannerEditar";

function AdminBanner({
    localizacao,
    onClose,
    onBannerAtualizado,
}) {
    const [banners, setBanners] = useState([]);
    const [bannerSelecionado, setBannerSelecionado] = useState(null);

    const carregarBanners = async () => {
        try {
            const response = await fetch(
                "https://app.eliandroalimentos.com.br/api/home_media/listar",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            const data = await response.json();

            const filtrados = data
                .filter((banner) =>
                    banner.localizacao === localizacao ||
                    banner.localizacao === `${localizacao}mobile`
                )
                .sort((a, b) => {
                    if (a.localizacao !== b.localizacao) {
                        return a.localizacao.localeCompare(b.localizacao);
                    }

                    return a.ordem - b.ordem;
                });

            setBanners(filtrados);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        carregarBanners();
    }, [localizacao]);

    const bannersDesktop = banners.filter(
        (b) => b.localizacao === localizacao
    );

    const bannersMobile = banners.filter(
        (b) => b.localizacao === `${localizacao}mobile`
    );

    return (
        <>
            <div className="admin-banner">
                <div className="admin-banner-header">
                    <h2>Editar Banners</h2>

                    <button onClick={onClose}>
                        X
                    </button>
                </div>

                <div className="admin-banner-colunas">

                    <div className="admin-banner-coluna">


                        <h3 className="admin-banner-titulo">
                            Banners Desktop
                        </h3>

                        <div className="admin-banner-lista">
                            {bannersDesktop.map((banner) => (
                                <div
                                    key={banner.id}
                                    className="admin-banner-item"
                                >
                                    <img
                                        src={banner.imagem}
                                        alt=""
                                    />

                                    <div>
                                        Banner {banner.ordem}
                                    </div>

                                    <button
                                        onClick={() =>
                                            setBannerSelecionado(banner)
                                        }
                                    >
                                        Editar
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="admin-banner-coluna">


                        <h3 className="admin-banner-titulo">
                            Banners Mobile
                        </h3>

                        <div className="admin-banner-lista">
                            {bannersMobile.map((banner) => (
                                <div
                                    key={banner.id}
                                    className="admin-banner-item admin-banner-item-mobile"
                                >
                                    <img
                                        src={banner.imagem}
                                        alt=""
                                    />

                                    <div>
                                        Banner Mob {banner.ordem}
                                    </div>

                                    <button
                                        onClick={() =>
                                            setBannerSelecionado(banner)
                                        }
                                    >
                                        Editar
                                    </button>
                                </div>
                            ))}

                        </div>
                    </div>
                </div>

            </div>
            {bannerSelecionado && (
                <AdminBannerEditar
                    banner={bannerSelecionado}
                    onClose={() => setBannerSelecionado(null)}
                    onSalvar={(bannerAtualizado) => {
                        carregarBanners();

                        onBannerAtualizado?.(bannerAtualizado);

                        setBannerSelecionado(null);
                    }}
                />
            )}
        </>
    );
}

export default AdminBanner;